import { render } from "./OfflineMode.vue?vue&type=template&id=dfea41e4"
import script from "./OfflineMode.vue?vue&type=script&lang=ts"
export * from "./OfflineMode.vue?vue&type=script&lang=ts"
script.render = render

export default script